import { UserLocation } from '@/types';

import { RootState } from '../types';

export const selectLocationById = (id?: UserLocation['id']) => (state: RootState) => {
  if (!id) return undefined;
  return state.reducer.userLocations.find(location => String(location.id) === String(id));
};
